import styled from "@emotion/styled"
import { keyframes } from "@emotion/react"
import AbstractBg from "../../images/abstractbg.jpg"
import Abstractbg2 from "../../images/book_seat_img.jpg"

export const animatedgradient = keyframes`
0% {
    background-position: 0 50%;
}
50% {
    background-position: 100% 50%;
}
100% {
    background-position: 0 50%;
}
`

export const MainContainer = styled.div`
  background-image: url(${AbstractBg});
  background: #000;

  opacity: 1;
  mix-blend-mode: multiply;

  padding-top: 90px;
  background-repeat: no-repeat;
  background-size: cover;
  margin-bottom: 13px;

  @media (max-width: 560px) {
    background-position-y: 0;
    padding: 50px 0;
    padding-bottom: 65px;
    margin-top: -50px;
  }
`
export const InnerContainer = styled.div`
  width: 60%;
  margin: auto;
  margin-top: 80px;
  padding-bottom: 100px;
  @media (max-width: 1440px) {
    width: 80%;
  }
  @media (max-width: 514px) {
    display: flex;
    justify-content: center;
    align-items: center;
    padding-bottom: 0px;
  }
`

export const Heading = styled.h1`
  display: block;
  font-family: Poppins;

  font-size: 50px;
  line-height: 1em;
  background-clip: text;
  display: block;
  color: #ffffff;

  text-align: center;
  margin: auto;
  width: 78%;
  margin-bottom: 40px;
  background: -webkit-linear-gradient(#eee, #333);
  background: linear-gradient(to right, #30cfd0 0%, #330867 100%);
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
  display: flex;
  align-items: center;
  justify-content: center;
  @media (max-width: 710px) {
    font-size: 35px;
    line-height: 39px;
    text-align: left;
  }
`

export const Subheading = styled.p`
  /* color:#ec38bc; */
  color: #fff;
  font-size: 18px;
  /* margin-top:5px; */
  font-family: Poppins;
  text-align: center;
  margin: auto;
  width: 78%;
  background: -webkit-linear-gradient(#eee, #333);
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
  display: flex;
  align-items: center;
  justify-content: center;
  @media (max-width: 710px) {
    text-align: left;
    align-items: flex-start;
  }
`

export const Flex = styled.div`
  display: flex;
  justify-content: space-between;
  @media (max-width: 1096px) {
    display: grid;
    grid-template-columns: auto auto;
    grid-row-gap: 50px;
  }
  @media (max-width: 528px) {
    grid-template-columns: auto;
  }
  @media (max-width: 400px) {
    grid-row-gap: 25px;
  }
`

export const Cta = styled.div`
  background: linear-gradient(to right, #03001e, #7303c0, #ec38bc);
  /* background:#03001e; */
  /* background:rgba(0,0,0,0.5); */
  /* border:2px solid #fff; */
  background-image: linear-gradient(90deg, #4f3ec8 0%, #8957f6 100%);
  box-sizing: border-box;
  animation: animatedgradient 3s ease infinite alternate;
  width: 220px;
  height: 50px;
  border-radius: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  font-family: Rubik;
  color: #fff;
  font-weight: 600;
  @media (max-width: 500px) {
    width: 241px;
    height: 52px;
    border-radius: 50px;
    font-size: 17px;
    font-weight: 600;
  }
  @media (max-width: 320px) {
    width: 259px;
  }
  &:hover {
    cursor: pointer;
    background: transparent;
    border: 1px solid #fff;
  }
`
